import React from "react";
import HeroPrices1 from "../components/HeroPrices1";
function PricesPages() {
  return (
    <div>
      <HeroPrices1></HeroPrices1>
    </div>
  );
}

export default PricesPages;
